<template>
  <div class="blog-lang">
    <a
      v-for="item in items"
      :href="item.href"
      class="blog-lang__link"
      :class="{ 'blog-lang__link_active': item.current }"
    >
      {{ item.name }}
    </a>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useResultsStore } from '@/storePinia/stores/results';

const resultsStore = useResultsStore();

const items = computed(() => resultsStore.siteLanguages.items);
</script>

<style lang="scss" scoped>
.blog-lang {
  display: flex;
  align-items: center;
  grid-area: lang;
  align-self: flex-start;
  font-weight: 500;
  font-size: rem(14);
  color: #5f5f67;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  @include point-md {
    justify-self: flex-end;
    font-size: rem(12);
  }
  &__link {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3px 6px;
    border: 1px solid var(--border-grey);
    border-radius: 2px;
    @include point-md {
      border: unset;
      padding: 0;
    }
    &:not(:last-child) {
      margin-right: 12px;
    }
    &_active {
      color: var(--color-main);
      border-color: var(--background-beige);
    }
  }
}
</style>
